import * as React from 'react';

class Preview extends React.Component<any> {
  render() {
    const { preview } = this.props;

    return (
      <img src={preview} style={{ width: '136px' }} alt="Player Preview" />
    );
  }
}

export default Preview;
